
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift-cards/balance",
      function () {
        return require("private-next-pages/gift-cards/balance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gift-cards/balance"])
      });
    }
  